(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.id = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Data tidak ditemukan'
      },
      combobox: {
        placeholder: 'Pilih',
        searchPlaceholder: 'Pencarian'
      },
      datepicker: {
        apply: 'Menerapkan',
        clearSelection: 'Hapus',
        pickADays: 'Pilih hari',
        prevYear: 'Tahun Sebelumnya',
        nextYear: 'Tahun Berikutnya',
        prevMonth: 'Bulan Sebelumnya',
        nextMonth: 'Bulan Berikutnya',
        year: '',
        month1: 'Januari',
        month2: 'Februari',
        month3: 'Maret',
        month4: 'April',
        month5: 'Mei',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'Agustus',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'Desember',
        weeks: {
          sun: 'Min',
          mon: 'Sen',
          tue: 'Sel',
          wed: 'Rab',
          thu: 'Kam',
          fri: 'Jum',
          sat: 'Sab'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'Mei',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Agt',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Des'
        },
        pickADay: 'Pilih hari'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Data tidak ditemukan'
      },
      filepicker: {
        browse: 'Jelajahi',
        select: 'Pilih file'
      },
      filter: {
        apply: 'Menerapkan',
        cancel: 'Batalkan',
        filterButton: 'Filter',
        reset: 'Reset filter',
        resetDefault: 'Setel ulang ke default'
      },
      search: {
        noDataMessage: 'Data tidak ditemukan'
      },
      'multi-search': {
        'separator-and': 'DAN',
        'search-button': 'Pencarian',
        'search-placeholder': 'Cari berdasarkan nama'
      },
      select: {
        all: 'Semua',
        clearSelection: 'Bersihkan pilihan',
        noMatch: 'Data tidak ditemukan',
        noData: 'Tidak ada data',
        placeholder: 'Pilih',
        item: 'item',
        selected: 'dipilih',
        found: 'ditemukan'
      },
      upload: {
        browseButton: 'Jelajahi',
        text: 'Seret dan jatuhkan file yang akan diunggah, atau klik "Telusuri"',
        tip: 'Anda dapat mengunggah 10 file maksimum 25 MB tiap filenya'
      },
      table: {
        emptyText: 'Tidak Ada Data'
      },
      tree: {
        emptyText: 'Tidak Ada Data'
      }
    }
  };
  _exports.default = _default;
});